module.exports = __webpack_public_path__ + "media/images/home/ic_edit-07967828cb62093353393eb77833be0f.svg";